import {
  MOBILE_SWAP_CONFIRMED_EVENT,
  MOBILE_SWAP_SESSION_EVENT,
} from '../domain/swap/mobileSwapSession'
import { useMobileSwapReceiptSync } from '../domain/swap/useMobileSwapReceiptSync'

/** Sincroniza hash/receipt del swap móvil a nivel app (sobrevive recargas al volver de MetaMask). */
export default function MobileSwapOutcomeSync() {
  useMobileSwapReceiptSync({
    onConfirmed: (hash) => {
      window.dispatchEvent(new CustomEvent(MOBILE_SWAP_CONFIRMED_EVENT, { detail: { hash } }))
    },
    onSessionUpdated: () => {
      window.dispatchEvent(new CustomEvent(MOBILE_SWAP_SESSION_EVENT))
    },
  })

  return null
}
